import { INTEGRATION_STATUS } from '@/entities/integrations';

export const INTEGRATION_STATUS_TO_I18_KEY = {
  [INTEGRATION_STATUS.INACTIVE]: 'integrations:status.inactive',
  [INTEGRATION_STATUS.ACTIVE]: 'integrations:status.active',
} as const;
